module.exports = __webpack_public_path__ + "static/media/edstep2img1.1025f078.png";